module.exports = __webpack_public_path__ + "img/personal.3f0403d2.svg";